import React from 'react';
import { autobind } from 'react-decoration';

import Pagination from './Pagination';

export default class FixedPagination extends Pagination {
  constructor(props) {
    super(props);
    this.state = {
      info: {
        nowpage: Math.ceil(props.start / props.limit) + 1, //props.startPageNo
        nextpage: false
      },
      fixed: '',
      pageCss: '',
      paginationCss: '',
      showPaginationCss: ''
    };

    this.showPage = React.createRef();
    this.pagination = React.createRef();
    this.fixPage = this.fixPage;
  }

  @autobind
  fixPage() {
    const { startPageNo, totalPage, showPrevious, showNext, pageNo } = this.props;
    /*
    if (
      $(this.pagination.current).offset().top >
      $('.data_content').height() + $('.data_content').offset().top - 50
    ) {
      this.setState({ fixed: '' });
    } else {
      this.setState({ fixed: 'fixed' });
    }*/

    let showPages = document.querySelectorAll('.showPageNo');
    let tempList = [];
    if (showPages) {
      showPages.forEach((e) => {
        if (Math.ceil(window.pageYOffset + (55 + 64)) >= e.getBoundingClientRect().top + window.pageYOffset) {
          tempList.push(e);
        }
      });
    }

    let nowpage =
      Math.max(
        0,
        Math.floor(
          tempList.length
        ) - 1
      ) + startPageNo;

   // nowpage = Math.min(nowpage, totalPage);

    let loadTotalPage = 0;
    if (showPages) {
      loadTotalPage = showPages.length;
    }

    let nps = [];
    for (var np = Math.max(1, nowpage - 3); np <= Math.min(nowpage + 3, totalPage); np++) {
      nps.push(np);
    }

    var info = {
      prevpage: showPrevious || nowpage > 1 || startPageNo < nowpage,
      nowpage: nowpage,
      nextpage: loadTotalPage > nowpage || showNext || nowpage < totalPage,
      lastpage: pageNo < totalPage || nowpage < totalPage,
      nps: nps
    };

    if (
      info.prevpage != this.state.info.prevpage ||
      info.nowpage != this.state.info.nowpage ||
      info.nextpage != this.state.info.nextpage ||
      info.lastpage != this.state.info.lastpage
    ) {
      this.setState({ info: info });
    }
  }

  componentDidMount() {
    this.fixPage();
    window.addEventListener("scroll", this.fixPage);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.fixPage);
  }

  componentWillReceiveProps(props) {
    this.setState(props);
  }

  @autobind
  showPaginationEvent() {
    this.setState({
      showPaginationCss: 'expansion'    
    });
  }

  @autobind
  closePaginationEvent() {
    this.setState({
      showPaginationCss: ''
    });
  }

  render() {
    const {
      nowpage,
      nps,
      prevpage: isPrevpage,
      nextpage: isNextpage,
      lastpage: isLastpage
    } = this.state.info;

    const {
      t,
      totalPage,
      pages,
      total,
      goPage,
      showNext,
      showPrevious,
      iFilterTotal,
      iTotal,
      limit,
      showpage,
      hasFilter,
      nFilterTotal,
      fetchMore,
      process,
      fetchMoreProcess,
      startPageNo
    } = this.props;

    const { fixed, pageCss, paginationCss, showPaginationCss } = this.state;

    let prevPage = Math.max(1, nowpage - 1);

    if (totalPage == 0) {
      return null;
    }

    
    return (
      <>
        <div ref={this.showPage}></div>
        <section
          ref={this.pagination}
          className={`pagination fixed ${showPaginationCss}`}>
          <ul className="page">
            <li className="first">
              <a
                href="javascript:;"
                tabIndex="0"
                title={t`jumperrwd.common.firstPage`}
                onClick={() => goPage(1)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    goPage(1);
                  }
                }}>
                {t`jumperrwd.common.firstPage` + " "}
              </a>
            </li>
            <li
              className="pageClose"
              tabIndex="0"
              onClick={this.closePaginationEvent}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  this.closePaginationEvent(e);
                }
              }}>
              <a
                href="javascript:;"
                title={t`jumperrwd.pagination.closePage`}>{t`jumperrwd.pagination.close`}</a>
            </li>
            {showPrevious && (
              <li className="prev">
                <a
                  href="javascript:;"
                  tabIndex="0"
                  onClick={() => goPage(prevPage)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      goPage(prevPage);
                    }
                  }}
                  title={t`jumperrwd.common.prevPage`}>
                  {t`jumperrwd.common.prevPage` + " "}
                </a>
              </li>
            )}
            {/*pages.map((page, key) => {
              return (
                <li key={`page_${key}`} className={nowpage == page.val ? 'active' : ''}>
                  <a href="javascript:;" onClick={() => goPage(page.val)}>
                    {page.val}
                  </a>
                </li>
              );
            })
          */}
            {showPaginationCss == "" && (
              <li className="active">
                <a
                  href="javascript:;"
                  tabIndex="0"
                  onClick={this.showPaginationEvent}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      this.showPaginationEvent(e);
                    }
                  }}>
                  {nowpage}
                </a>
              </li>
            )}

            {this.state.info.nps != null &&
              showPaginationCss == "expansion" &&
              this.state.info.nps.map((item, key) => (
                <li className={this.state.info.nowpage == item ? "active" : ""}>
                  <a
                    href="javascript:;"
                    tabIndex="0"
                    onClick={() => this.props.goPage(item)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        this.props.goPage(item);
                      }
                    }}>
                    {item}
                  </a>
                </li>
              ))}

            {showNext && (
              <li className="next">
                <a
                  href="javascript:;"
                  tabIndex="0"
                  title={t`jumperrwd.common.nextPage`}
                  onClick={() => goPage(nowpage + 1)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      goPage(nowpage + 1);
                    }
                  }}>
                  {t`jumperrwd.common.nextPage` + " "}
                </a>
              </li>
            )}
            {isLastpage && (
              <li className="last">
                <a
                  href="javascript:;"
                  tabIndex="0"
                  title={t`jumperrwd.common.lastPage`}
                  onClick={() => goPage(totalPage)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      goPage(totalPage);
                    }
                  }}>
                  {t`jumperrwd.common.lastPage` + " "}
                </a>
              </li>
            )}
          </ul>
        </section>
      </>
    );
  }
}
